import { Box, Typography, Container, Divider, SvgIcon } from "@mui/material";
import { Link } from "react-router-dom";
import { KeyboardBackspace } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
// import img54 from "../../assets/newimg/logo.png";
import img54 from "../../assets/ocesha_images/ocesha_logo.png";
import { useState, useEffect } from "react";

import { object, string, TypeOf } from "zod";
import { useSubscribeNewsMutation } from "../../redux/api/authApi";
import { toast } from "react-toastify";
import { useForm, FormProvider, SubmitHandler } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

const newsSubscribeform = object({
  email: string()
    .min(1, "Email address is required")
    .email("Email address is invalid"),
  status: string(),
});

export type NewsSubscriptionForm = TypeOf<typeof newsSubscribeform>;
const Aiacceptable = () => {
  const navigate = useNavigate();

  const handleLearnMore = () => {
    navigate("/codegenie/smart_contracts");
  };
  const [subscribeVal, setSubscribeVal] = useState<NewsSubscriptionForm>({
    email: "",
    status: "",
  });
  const [newsSubsctiptionMutation, newsSubscriptionState] =
    useSubscribeNewsMutation();

  const methods = useForm<NewsSubscriptionForm>({
    resolver: zodResolver(newsSubscribeform),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = methods;

  const onSubmitHandler: SubmitHandler<NewsSubscriptionForm> = (values) => {
    newsSubsctiptionMutation(values);
  };

  const handleSubscribeNews = () => {
    newsSubsctiptionMutation(subscribeVal)
      .unwrap()
      .then((response) => {
        console.log("news subscription=>", response);
        const status = response.status;

        console.log(status);
        if (status === "success") {
          toast.success(response.message);
          setSubscribeVal({
            email: "",
            status: "",
          });
        }
      })
      .catch((error) => {
        toast.error(error?.data?.detail ?? "Something went wrong!");
        console.error("Error sending query:", error);
      });
  };
  return (
    <>
      <Container maxWidth="lg">
        <nav className="navbar navbar-expand-md">
          <div className="container-fluid">
            <a className="navbar-brand" href="/">
              {/* <img src="./img/logo.png" alt="" /> */}
              <img src={img54} alt="" style={{ height: "70px" }} />
              {/* <img src={logo} alt="" /> */}
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarScroll"
              aria-controls="navbarScroll"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="">
                <i className="bi bi-list text-white" />
              </span>
            </button>

            <div className="collapse navbar-collapse" id="navbarScroll">
              <ul className="navbar-nav me-auto my-2 my-lg-0 navbar-nav-scroll gap-4">
                {/* ms-md-5 */}
                <li className="nav-item">
                  <a
                    className="nav-link nav_active"
                    style={{ color: "#4ba5eb", fontWeight: 800 }}
                    href="/"
                  >
                    Home
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link nav_simple"
                    href="https://ocesha-inc.getrewardful.com/signup?_gl=1*1lh53li*_gcl_au*MTc0Njg4MTI3Ni4xNzQ2NzMwMTA0*_ga*MTY2NzI5OTM0OC4xNzQ2NzMwMTA0*_ga_YJYFH7ZS27*czE3NDY3MzAxMDMkbzEkZzEkdDE3NDY3MzEwNjckajM3JGwwJGgw"
                  >
                    Affiliate
                  </a>
                </li>
              </ul>

              <div className="d-flex gap-4" role="search">
                <button
                  className="button_leniar px-3"
                  type="submit"
                  onClick={() => {
                    navigate("/signup");
                  }}
                >
                  Try Now
                </button>
                <button
                  className="btn btn-outline-primary px-3"
                  onClick={() => {
                    navigate("/signin");
                  }}
                >
                  Sign in
                </button>
              </div>
            </div>
          </div>
        </nav>
        <Box py={5}>
          <Typography
            variant="h2"
            color="text.secondary"
            fontWeight={600}
            textAlign="justify"
            mb={10}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              OceSha.ai AI Acceptable Use Addendum
            </div>
          </Typography>
          <Typography>
            Last Updated: March 1, 2026
            <br />
            <br />
            This AI Acceptable Use Addendum (“AI Policy”) forms part of the
            OceSha Terms of Service and governs your use of all AI-powered
            features of the Services, including but not limited to Digital Twin
            technology, content generation, voice synthesis, automated course
            creation, AI agents, and any related generative systems
            (collectively, “AI Services”). <br />
            <br />
            By using OceSha’s AI Services, you agree to comply with this AI
            Policy.
          </Typography>
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            1. Purpose of the AI Services
          </Typography>
          <Typography>
            OceSha provides AI-powered infrastructure designed to:
            <Box component="ul">
              <Box component="li">Amplify human expertise</Box>
              <Box component="li">
                Automate knowledge structuring and publishing
              </Box>
              <Box component="li">Enable Digital Twin-based instruction</Box>
              <Box component="li">
                Assist in business and educational scaling
              </Box>
            </Box>
            The AI Services are tools designed to enhance — not replace — human
            expertise. <br />
            <br />
            You remain fully responsible for how you use AI-generated Output.
          </Typography>
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            2. Prohibited AI Uses
          </Typography>
          <Typography>
            You may not use the AI Services for any of the following:
          </Typography>
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            2.1 Impersonation & Deceptive Practices
          </Typography>
          <Typography>
            <Box component="ul">
              <Box component="li">
                Cloning a voice or identity without explicit written
                authorization
              </Box>
              <Box component="li">
                Creating AI-generated content that falsely represents a real
                person
              </Box>
              <Box component="li">
                Using Digital Twins for impersonation, fraud, or deception
              </Box>
              <Box component="li">
                Presenting AI-generated content as live human communication when
                it is not
              </Box>
            </Box>
          </Typography>
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            2.2 Harmful or Illegal Content
          </Typography>
          <Typography>
            You may not use the Services to generate or distribute:
            <Box component="ul">
              <Box component="li">Criminal content or instructions</Box>
              <Box component="li">
                Harassment, hate speech, or discriminatory content
              </Box>
              <Box component="li">
                Sexually explicit or exploitative material
              </Box>
              <Box component="li">Child exploitation material</Box>
              <Box component="li">Defamatory or knowingly false statements</Box>
              <Box component="li">Violent or threatening content</Box>
            </Box>
          </Typography>
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            2.3 Intellectual Property Violations
          </Typography>
          <Typography>
            You may not:
            <Box component="ul">
              <Box component="li">
                Upload content you do not own or have rights to
              </Box>
              <Box component="li">
                Train a Digital Twin on copyrighted material without
                authorization
              </Box>
              <Box component="li">
                Use the AI Services to replicate proprietary frameworks without
                permission
              </Box>
              <Box component="li">
                Extract proprietary prompts, system instructions, or internal
                architecture
              </Box>
            </Box>
          </Typography>
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            2.4 Regulatory or Professional Violations
          </Typography>
          <Typography>
            You may not use the AI Services to provide:
            <Box component="ul">
              <Box component="li">Unauthorized medical advice</Box>
              <Box component="li">Unauthorized legal advice</Box>
              <Box component="li">Financial or investment guarantees</Box>
              <Box component="li">
                Regulated professional services without appropriate licensing
              </Box>
            </Box>
            You remain solely responsible for compliance with all applicable
            professional regulations.
          </Typography>
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            2.5 Model Exploitation & Infrastructure Abuse
          </Typography>
          <Typography>
            You may not:
            <Box component="ul">
              <Box component="li">Reverse engineer the AI systems</Box>
              <Box component="li">
                Extract model weights or proprietary training signals
              </Box>
              <Box component="li">Attempt prompt injection attacks</Box>
              <Box component="li">
                Use automated scraping or extraction tools
              </Box>
              <Box component="li">
                Build competing AI systems using OceSha infrastructure
              </Box>
            </Box>
          </Typography>
          <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            3. Digital Twin Ethical Standards
          </Typography>
          <Typography>
            Because OceSha provides Digital Twin voice and instructional
            simulation capabilities: <br /> <br />
            You agree that:
            <Box component="ul">
              <Box component="li">You will only create a Digital Twin of yourself or someone you are legally authorized to represent</Box>
              <Box component="li">You will not use Digital Twin technology to simulate consent, authority, or credentials you do not possess</Box>
              <Box component="li">You will clearly disclose when appropriate that instructional content is AI-assisted</Box>
            </Box>
            OceSha reserves the right to suspend or disable
            Digital Twin features if misuse is suspected.
          </Typography>
           <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            4. Human Oversight Requirement
          </Typography>
          <Typography>
           <Box component="ul">
              You acknowledge and agree that:
              <Box component="li">AI-generated Output may contain inaccuracies (“hallucinations”)</Box>
              <Box component="li">AI Output may not be unique</Box>
              <Box component="li">AI Output is probabilistic, not deterministic</Box>
            </Box>
            You are responsible for reviewing and validating Output before publication, monetization, or distribution. <br /> <br />
            OceSha is not responsible for business, reputational, or regulatory harm arising from unreviewed AI Output.
          </Typography>
           <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            5. Content Moderation & Enforcement
          </Typography>
          <Typography>
           OceSha may:
           <Box component="ul">
              <Box component="li">Monitor AI usage patterns</Box>
              <Box component="li">Remove or disable Output</Box>
              <Box component="li">Suspend accounts</Box>
              <Box component="li">Permanently terminate access</Box>
            </Box>
           if, in our sole discretion, your usage:
           <Box component="ul">
              <Box component="li">Violates this AI Policy</Box>
              <Box component="li">Poses legal or regulatory risk</Box>
              <Box component="li">Threatens platform integrity</Box>
              <Box component="li">Harms other users</Box>
            </Box>
           We may act without prior notice in cases of severe misuse.
          </Typography>
           <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            6. Reporting Misuse
          </Typography>
          <Typography>
           If you believe AI Services are being used to:
           <Box component="ul">
              <Box component="li">Impersonate you</Box>
              <Box component="li">Infringe your intellectual property</Box>
              <Box component="li">Generate harmful or illegal content</Box>
            </Box>
             Contact: <Link
                          to=""
                          onClick={(e) => {
                            window.location.href = `mailto:support@ocesha.com`;
                            e.preventDefault();
                          }}
                          style={{
                            color: "#0168B5",
                          }}
                        >
                          support@ocesha.com 
                        </Link>  <br /> <br />
           We take misuse reports seriously.
          </Typography>
           <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            7. AI Output Transparency
          </Typography>
          <Typography>
           You acknowledge:
           <Box component="ul">
              <Box component="li">AI Outputs may resemble other outputs generated for other users</Box>
              <Box component="li">The AI Services do not guarantee exclusivity or originality</Box>
              <Box component="li">You are responsible for conducting originality checks when necessary</Box>
            </Box>
          </Typography>
           <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            8. Updates to AI Policy
          </Typography>
          <Typography>
           Given the evolving nature of AI regulation, OceSha may update this AI Acceptable Use Addendum as regulatory frameworks develop. <br /> <br />
           Continued use of the Services constitutes acceptance of updated terms.
          </Typography>
           <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
            9. Relationship to Terms of Service
          </Typography>
          <Typography>
           This AI Policy supplements and forms part of the OceSha Terms of Service. <br /><br />
           In the event of conflict, the stricter provision applies.
          </Typography>
          <Link
            to="/signin"
            style={{
              display: "flex",
              marginTop: 40,
              textDecoration: "none",
              color: "white",
            }}
          >
            <SvgIcon sx={{ mr: 1 }}>
              <KeyboardBackspace />
            </SvgIcon>
            Back to log in
          </Link>
        </Box>
      </Container>
    </>
  );
};

export default Aiacceptable;
